module.exports = __webpack_public_path__ + "static/img/lenx-logo-footer-dark.5860a68d.svg";